module.exports = __webpack_public_path__ + "static/img/upgrade.ccbd1618.svg";